import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Browse from "./pages/Browse";
import HandymanDetail from "./pages/HandymanDetail";
import Dashboard from "./pages/Dashboard";
import HandymanDashboard from "./pages/HandymanDashboard";
import Messages from "./pages/Messages";
import PaymentSuccess from "./pages/PaymentSuccess";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import Careers from "./pages/Careers";
import NotificationsSettings from "./pages/NotificationsSettings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-charcoal/60">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/handymen/:id" element={<HandymanDetail />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/handyman" element={<Protected><HandymanDashboard /></Protected>} />
        <Route path="/messages" element={<Protected><Messages /></Protected>} />
        <Route path="/messages/:otherId" element={<Protected><Messages /></Protected>} />
        <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/settings/notifications" element={<Protected><NotificationsSettings /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster richColors position="top-center" />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
